document.documentElement.classList.add('nh-js');

const revealItems = document.querySelectorAll('[data-nh-reveal]');

if ('IntersectionObserver' in window && revealItems.length > 0) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('nh-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.18 }
  );

  revealItems.forEach((item) => observer.observe(item));
} else {
  revealItems.forEach((item) => item.classList.add('nh-revealed'));
}

document.querySelectorAll('[data-nh-tabs]').forEach((tabs) => {
  const buttons = tabs.querySelectorAll('[data-nh-tab]');
  const panels = tabs.querySelectorAll('[data-nh-panel]');

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const target = button.getAttribute('data-nh-tab');

      buttons.forEach((item) => {
        item.setAttribute('aria-selected', item === button ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.getAttribute('data-nh-panel') === target);
      });
    });
  });
});

const isNeoHairProduct = window.location.pathname.includes('/products/neo-hair-lotion-original-derma-roller');

if (isNeoHairProduct) {
  const assurance = document.querySelector('.nh-product-assurance');
  const description = document.querySelector('.nh-product-description');
  const codNote = document.querySelector('.nh-product-cod-note span');
  const firstBenefit = document.querySelector('.nh-product-benefits li:first-child');

  if (assurance && !document.querySelector('.nh-product-includes')) {
    assurance.insertAdjacentHTML(
      'afterend',
      `<div class="nh-product-includes" aria-label="What is included">
        <span>Inside the combo</span>
        <ul>
          <li>Neo Hair Lotion Original pack</li>
          <li>Derma roller support tool</li>
          <li>Online or COD purchase choice</li>
        </ul>
      </div>`
    );
  }

  if (description && !description.textContent.includes('consistent scalp-care routine')) {
    description.innerHTML = `
      <p><strong>Neo Hair Lotion Original</strong> by Green Wealth, made in Thailand. This combo includes Neo Hair Lotion and a derma roller for a consistent scalp-care routine.</p>
      <ul>
        <li>Original product details are shown clearly before checkout.</li>
        <li>Use exactly as directed on the product label.</li>
        <li>Keep the routine consistent and evaluate results realistically over time.</li>
        <li>Individual results vary. Consult a qualified professional for medical scalp concerns.</li>
      </ul>
      <p><strong>Pricing:</strong> Online purchase Rs. 2,400. Cash on delivery Rs. 2,600.</p>
      <p><strong>Support:</strong> WhatsApp help is available on 8590884551 before checkout.</p>
    `;
  }

  if (codNote) {
    codNote.textContent = 'Add to cart and choose Cash on Delivery during standard checkout where available.';
  }

  if (firstBenefit) {
    firstBenefit.textContent = 'Verify the seal, origin details, and batch information before use.';
  }
}

document.querySelectorAll('.nh-product-form').forEach((form) => {
  const select = form.querySelector('.nh-variant-select');
  const buttons = form.querySelectorAll('[data-nh-variant-id]');
  const prices = document.querySelectorAll('[data-nh-product-price]');

  if (!select || buttons.length === 0) return;

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      select.value = button.getAttribute('data-nh-variant-id');
      select.dispatchEvent(new Event('change', { bubbles: true }));

      buttons.forEach((item) => item.classList.toggle('is-active', item === button));

      if (prices.length > 0 && button.dataset.nhVariantPrice) {
        prices.forEach((price) => {
          price.textContent = button.dataset.nhVariantPrice;
        });
      }

      const submit = form.querySelector('button[name="add"]');
      if (submit && button.dataset.nhVariantPrice) {
        submit.textContent = `Add to cart - ${button.dataset.nhVariantPrice}`;
      }
    });
  });
});

const stickyOrder = document.querySelector('.nh-sticky-order');
const hero = document.querySelector('.nh-hero');
const mobileQuery = window.matchMedia('(max-width: 680px)');

if (stickyOrder && hero) {
  let ticking = false;

  const updateStickyOrder = () => {
    const heroBottom = hero.getBoundingClientRect().bottom;
    const shouldShow = heroBottom < window.innerHeight * 0.58;
    document.documentElement.classList.toggle('nh-sticky-visible', shouldShow);
    ticking = false;
  };

  const requestStickyUpdate = () => {
    if (!ticking) {
      window.requestAnimationFrame(updateStickyOrder);
      ticking = true;
    }
  };

  updateStickyOrder();
  window.addEventListener('scroll', requestStickyUpdate, { passive: true });
  window.addEventListener('resize', requestStickyUpdate);
  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', requestStickyUpdate);
  } else {
    mobileQuery.addListener(requestStickyUpdate);
  }
}

const productStickyBuy = document.querySelector('.nh-product-sticky-buy');
const productSummary = document.querySelector('.nh-product-summary');

if (productStickyBuy && productSummary) {
  let ticking = false;

  const updateProductStickyBuy = () => {
    const summaryTop = productSummary.getBoundingClientRect().top;
    const shouldShow = mobileQuery.matches && window.scrollY > 360 && summaryTop < window.innerHeight * 0.72;
    document.documentElement.classList.toggle('nh-product-sticky-visible', shouldShow);
    ticking = false;
  };

  const requestProductStickyUpdate = () => {
    if (!ticking) {
      window.requestAnimationFrame(updateProductStickyBuy);
      ticking = true;
    }
  };

  updateProductStickyBuy();
  window.addEventListener('scroll', requestProductStickyUpdate, { passive: true });
  window.addEventListener('resize', requestProductStickyUpdate);
  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', requestProductStickyUpdate);
  } else {
    mobileQuery.addListener(requestProductStickyUpdate);
  }
}
